import { render, staticRenderFns } from "./AdminAnnouncementIndex.vue?vue&type=template&id=2da74cea&scoped=true&"
import script from "./AdminAnnouncementIndex.vue?vue&type=script&lang=js&"
export * from "./AdminAnnouncementIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da74cea",
  null
  
)

export default component.exports